module.exports = __webpack_public_path__ + "img/pcr1.afe16ccd.png";